export const videoReset = () => {
  const iframe = document.querySelector('iframe')
  iframe?.contentWindow?.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
}
